import { ref } from "vue";

type ValidationError = { field: string; message: string[] };

/**
 * Composition API equivalent of validationErrorMixin.
 */
export function useValidationErrors() {
    const validationErrors = ref<Record<string, string[]>>({});

    function getFormGroupClass(field: string): string {
        return validationErrors.value[field] ? "field form-group has-error" : "field form-group";
    }

    function getValidationMessage(field: string): string {
        return validationErrors.value[field] ? validationErrors.value[field].join(" ") : "";
    }

    function clearValidationErrors(): void {
        validationErrors.value = {};
    }

    function updateValidationErrors(errors: ValidationError[] | undefined): void {
        const newValidationErrors: Record<string, string[]> = {};
        (errors || []).forEach(error => {
            newValidationErrors[error.field] = error.message;
        });
        validationErrors.value = newValidationErrors;
    }

    return {
        getFormGroupClass,
        getValidationMessage,
        clearValidationErrors,
        updateValidationErrors,
    };
}
